import React, { useEffect } from "react";
import About from "../components/sections/About";
import WhyUs from "../components/sections/WhyUs";
import Process from "../components/sections/Process";
import Investment from "../components/sections/Investment";
import FinalCTA from "../components/sections/FinalCTA";
import useSEO from "../hooks/useSEO";
import { useLang } from "../context/LanguageContext";

export default function AboutPage() {
  const { lang } = useLang();
  useSEO({
    title: lang === "pl" ? "O nas — LK LOG" : "About us — LK LOG",
    description:
      lang === "pl"
        ? "Logistyka oparta na doświadczeniu, odpowiedzialności i partnerstwie. Od 2020 roku rozwijamy LK LOG — zespół z ponad 30-letnim doświadczeniem w transporcie."
        : "Logistics built on experience, accountability and partnership. Since 2020 we've been building LK LOG with a team of 30+ years of transport experience.",
    path: "/o-nas",
    lang,
  });
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);
  return (
    <main data-testid="about-page" className="pt-20">
      <About />
      <WhyUs />
      <Process />
      <Investment />
      <FinalCTA />
    </main>
  );
}
